/**
 * Jednotny pohyb pre vsetky interaktivne prvky portalu.
 *
 * HARD RULE: ziadny hover bez transition a bez easingu.
 * Easing token --ease-rx zije v app/globals.css.
 *
 * Pozn. k Tailwind v4: -translate-y / scale sa kompiluju do CSS vlastnosti
 * `translate:` a `scale:`, NIE do `transform:`. Preto sa vzdy pouziva `transition`
 * (ktora ich zahrna), nikdy `transition-transform` - inak hover skoci bez animacie.
 */
export const MOTION = 'transition duration-200 ease-[var(--ease-rx)]';

/** Jemny zdvih pri hoveri, na active sa vracia dole. */
export const LIFT = 'hover:-translate-y-[1px] active:translate-y-0';
